import React from 'react'
import PersonalImageCard from './PersonalImageCard'
import Card from '../../../../reusableComponents/cards/Card71'

const PersonalImageComponent = () => {
    return (
        <div className="w-full h-full">
            <Card
                title='Personal Information'
                showPrimaryButton={false}
                showSecondaryButton={false}
                showSwapComponent1={true}
                showSwapComponent2={false}
                showSwapComponent3={false}
                showDescription={false}
                swapContent1={<PersonalImageCard />}
                showMenuButton={false}
                className="h-full lg:h-auto" 
            />
        </div>
    )
}

export default PersonalImageComponent